import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      minHeight: '60px',
      minWidth: '60px',
      background: theme.palette.background.default,
      '&$fullScreen': {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      }
    },
    noAnimate: {},
    fullScreen: {},
    circleWrapper: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    outerCircle: {
      borderColor: theme.palette.primary.main,
      borderTopColor: 'rgba(0,0,0,0)',
      borderLeftColor: 'rgba(0,0,0,0)',
      boxShadow: `0 0 35px ${theme.palette.primary.main}`,

      backgroundColor: 'rgba(0, 0, 0, 0)',
      border: '5px solid rgba(0, 0, 0, 0.87)',
      opacity: 0.9,
      borderTop: '5px solid rgba(0, 0, 0, 0)',
      borderLeft: '5px solid rgba(0, 0, 0, 0)',
      borderRadius: '50px',
      width: '50px',
      height: '50px',
      transformOrigin: '50% 50%',
      animation: 'spin 0.5s infinite linear',
      '&$noAnimate': {
        animation: 'none',
        transition: 'none'
      }
    },
    innerCircle: {
      borderColor: theme.palette.primary.main,
      borderTopColor: 'rgba(0,0,0,0)',
      borderLeftColor: 'rgba(0,0,0,0)',
      boxShadow: `0 0 15px ${theme.palette.primary.main}`,

      backgroundColor: 'rgba(0, 0, 0, 0)',
      border: '5px solid rgba(0, 0, 0, 0.87)',
      opacity: 0.9,
      borderTop: '5px solid rgba(0, 0, 0, 0)',
      borderLeft: '5px solid rgba(0, 0, 0, 0)',
      borderRadius: '50px',
      width: '30px',
      height: '30px',
      transformOrigin: '50% 50%',
      animation: 'spinoff 0.5s infinite linear',
      '&$noAnimate': {
        animation: 'none',
        transition: 'none'
      }
    }
  });

export interface PageLoaderProps {
  fullScreen?: boolean;
  noAnimate?: boolean;
}
type Props = PageLoaderProps & WithStyles<typeof styles>;

const PageLoader = withStyles<'root', {}, PageLoaderProps>(styles, {
  name: 'FdPageLoader'
})((props: Props) => {
  const { classes, fullScreen, noAnimate } = props;

  const cn = clsx(classes.root, {
    [classes.fullScreen]: fullScreen
  });
  const ocn = clsx(classes.outerCircle, {
    [classes.noAnimate]: noAnimate
  });
  const icn = clsx(classes.innerCircle, {
    [classes.noAnimate]: noAnimate
  });

  return (
    <div className={cn}>
      <div className={classes.circleWrapper}>
        <div className={ocn} />
      </div>
      <div className={classes.circleWrapper}>
        <div className={icn} />
      </div>
    </div>
  );
});

PageLoader.defaultProps = {
  fullScreen: true,
  noAnimate: process.env.NODE_ENV === 'test'
};

export default PageLoader;
